import type { IconProps } from '@hedepy/icons/Icon'
import { cloneElement, isValidElement, type ReactElement, type ReactNode } from 'react'

import { cn } from '@/legacy-src/lib/utils'

import { Text } from '@/src/domains/design-system/components/Text'

export type TherapistCardIconTextProps = {
  icon?: ReactElement<IconProps>
  className?: string
  children: ReactNode
}

export const TherapistCardIconText = ({ icon, className, children }: TherapistCardIconTextProps) => (
  <div className={cn('flex flex-row items-center gap-2', className)}>
    {isValidElement<IconProps>(icon)
      ? cloneElement(icon, {
          className: cn('shrink-0', icon.props.className),
        })
      : null}
    <Text element="div" variant="sm" weight="bold">
      {children}
    </Text>
  </div>
)
